<template>
  <div>
    <div class="iframe-wrapper">
      <iframe
        v-if="video.type === 'vimeo'"
        :src="`https://player.vimeo.com/video/${video.id}`"
        :title="video.title"
        class="video-iframe"
        allowfullscreen
      />
      <iframe
        v-else
        :src="`https://www.youtube.com/embed/${video.id}`"
        :title="video.title"
        class="video-iframe"
        allowfullscreen
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

defineOptions({
  name: 'VideoBlock',
});

const video = ref(parseVideo(props.config.video?.url));

/**
 * Parses a video URL and returns type (youtube/vimeo), id, and title.
 * Supports YouTube and Vimeo URL formats including relative URLs.
 */
function parseVideo(url) {
  const regex =
    /(http:\/\/|https:\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/;
  const match = url?.match(regex);
  let type = null;
  let id = '';
  if (match) {
    const host = match[3] ?? '';
    id = match[6] ?? '';
    if (host.indexOf('youtu') > -1) {
      type = 'youtube';
    } else if (host.indexOf('vimeo') > -1) {
      type = 'vimeo';
    }
  }
  return {
    type,
    id,
    title: props.config?.video?.title || '',
  };
}
</script>

<style scoped>
.iframe-wrapper {
  position: relative;
  height: 0;
  padding-top: 56.25%;
  overflow: hidden;
}
.iframe-wrapper iframe {
  border-style: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
